







































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  minLength,
  sameAs
} from "vuelidate/lib/validators";

import { getFieldError } from "@/core/tools/forms/get_field_error";

import { STORE_KEY as PARENT_STORE_KEY } from "../_store";
import { STORE_KEY, store } from "./_store";
import Attachments from "@/components/Controls/Attachments.vue";

@Component({
  mixins: [validationMixin],
  computed: {
    ...mapState(PARENT_STORE_KEY, ["document"]),
    ...mapState(STORE_KEY, [
      "loaded",
      "loading",
      "fatalError",
      "form",
      "formDirty",
      "meta"
    ]),
    ...mapGetters(STORE_KEY, ["fields"])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      name: { required, minLength: minLength(3) },
      code: {},
      entity_id: { required },
      inn: {},
      code_1s: {},
      parent_id: {},
      head_id: {},
      distributor_id: {},
      agent_id: {},
      type_id: { required },
      market_type: { required },
      category: { required },
      client_sector_id: {},
      client_segment_id: {},
      business_scope_id: { required },
      city_id: { required },
      competitor_trademark: { required },
      contacts: {},
      credit: {},
      delivery_warehouse_id: { required },
      destination_warehouse_id: {},
      manager_id: { required },
      month_weight_plan: {},
      payment_deferment_period_id: { required },
      payment_type_id: { required },
      preferred_product_container_id: {},
      preferred_product_container_2_id: {},
      preferred_product_container_3_id: {},
      primary_contact_type: {},
      secondary_manager_id: {},
      source: { required },
      color: {},
      lk_allow_calc_containers: {},
      lk_allow_calc_weight: {},
      legal_address: {},
      requesites: {},
      attachments: {},
      no_take_in_plan: {},
      deal_comment: {},
      custom_plan: {},
      special_orders: {}
    };

    return {
      form: rules
    };
  },
  components: {
    Attachments
  }
})
export default class ClientForm extends Vue {
  document!: any;
  form!: any;

  /** DocAPI id типа клиента code=distributor; резолвится на mount. */
  distributorTypeId: string = "";

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    console.log("mounted", this.document, this.document.id);
    this.resolveDistributorTypeId();
    if (this.document.id) {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.document.id
      });
    } else {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`);
    }
    this.$v.form.$touch();
  }

  resolveDistributorTypeId() {
    (this as any)
      .$db([
        (this as any)
          .$q("RESOLVE_DISTRIBUTOR_TYPE")
          .raw("documents.list")
          .action({
            columns: {
              id: "ct.id",
              code: "ct.code"
            },
            from: "s:client_types",
            from_as: "ct",
            where: {
              $eq: ["ct.code", { $: "distributor" }]
            },
            page_size: 1
          })
      ])
      .then((result: any) => {
        const docs =
          result.getOperation("RESOLVE_DISTRIBUTOR_TYPE").getContent()
            .documents || [];
        if (docs.length && docs[0].id) {
          this.distributorTypeId = docs[0].id;
        }
      })
      .catch(() => {
        this.distributorTypeId = "";
      });
  }

  changeValue(field: string, value: any) {
    if (
      field === "distributor_id" &&
      value &&
      this.document &&
      this.document.id &&
      value === this.document.id
    ) {
      value = null;
    }
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field,
      newValue: value
    });

    // @ts-ignore
    this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  toggleCredentials(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/toggleCredentials`);

    if (this.$v.form.credentials) {
      // @ts-ignore
      this.$v.form.credentials.$touch();
    }

    // this.$v.form.$touch();
  }

  changeCredentialsValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeCredentialsValue`, {
      field,
      newValue: value
    });

    // @ts-ignore
    this.$v.form.credentials[field].$touch();
    // this.$v.form.$touch();
  }

  toggleRoleSelection(roleId: string) {
    this.$store.dispatch(`${STORE_KEY}/toggleRoleSelection`, roleId);

    if (this.$v.form.roles) {
      this.$v.form.roles.$touch();
    }

    // this.$v.form.$touch();
  }

  saveFormData() {
    this.$v.form.$touch();

    if (!this.$v.form.$error) {
      this.$store
        .dispatch(`${STORE_KEY}/saveForm`, {
          id: this.document.id
        })
        .then(result => {
          this.$buefy.snackbar.open(`Данные успешно сохранены`);
          this.$v.form.$reset();

          this.$emit("on-need-data-reload", result.document.id);
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: "is-warning",
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          });
        });
    }
  }

  addAttachments(file: any) {
    this.form.attachments.push(file);
    // this.saveFormData()
  }

  removeFile(idx: number) {
    this.form.attachments.splice(idx, 1);
    // this.saveFormData()
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}
